import React from 'react';
import PropTypes from 'prop-types';
import { Anchor, Box, Button, Heading, Tag, Text } from 'grommet';
import { Utils } from '../helpers/Utils';
import { useRecentEventsInfinite } from '../hooks/useRecentEventsInfinite';

export const RecentActivity = ({
    companySlug,
    contactHref,
    heading = 'Recent Activity',
}) => {
    const { allEvents, loadMore, loading, hasMore } =
        useRecentEventsInfinite(companySlug);

    return (
        <Box gap="small">
            <Heading level="4" margin="none">
                {heading}
            </Heading>
            <Box
                pad="medium"
                elevation="small"
                round="small"
                gap="small"
                height={{ max: 'large' }}
                overflow={{ vertical: 'auto' }}>
                {allEvents.length === 0 && !loading && (
                    <Text size="small" color="dark-4">
                        No recent activity
                    </Text>
                )}
                {allEvents.map((event) => (
                    // flex={false} stops the scrolling column from shrinking
                    // rows below their natural height once they overflow.
                    <Box
                        key={event.id}
                        direction="row"
                        gap="medium"
                        align="center"
                        flex={false}>
                        <Tag
                            value={new Date(
                                event.createdAt,
                            ).toLocaleDateString()}
                            size="xsmall"
                        />
                        <Text size="small">
                            <Anchor
                                href={contactHref(event.contact)}
                                label={`${event.contact.firstName} ${event.contact.lastName}`}
                            />{' '}
                            {Utils.convertEnumStringToLabel(event.type)}
                        </Text>
                    </Box>
                ))}
            </Box>
            {hasMore && (
                <Box align="center">
                    <Button
                        label={loading ? 'Loading…' : 'Load more'}
                        disabled={loading}
                        onClick={loadMore}
                    />
                </Box>
            )}
            {!hasMore && allEvents.length > 0 && (
                <Box align="center">
                    <Text size="small" color="dark-4">
                        All {allEvents.length} activities loaded
                    </Text>
                </Box>
            )}
        </Box>
    );
};

RecentActivity.propTypes = {
    companySlug: PropTypes.string,
    contactHref: PropTypes.func.isRequired,
    heading: PropTypes.string,
};
